import { RichTextNodeType } from "@prismicio/types-internal/lib/customtypes"
import type { Editor } from "@tiptap/core"

import { DocumentsModal } from "../../../LinkField/Documents/DocumentsModal"
import { createRunCommandsFn } from "../../models/MenuItems"

interface SetDocumentLinkModalProps {
  open: boolean
  setOpen: (open: boolean) => void
  editor: Editor
}

export function SetDocumentLinkModal(props: SetDocumentLinkModalProps) {
  const { open } = props
  const { onOpenChange, onSelectDocument } = useLinkModal(props)

  return (
    <DocumentsModal
      open={open}
      onOpenChange={onOpenChange}
      onSelectDocument={onSelectDocument}
    />
  )
}

function useLinkModal(props: SetDocumentLinkModalProps) {
  const { editor, setOpen } = props

  function onSelectDocument(id: string) {
    const setLink = createRunCommandsFn((commands) =>
      commands
        .extendMarkRange(RichTextNodeType.hyperlink)
        .setDocumentLink({ id: id }),
    )
    setLink(editor)
    setOpen(false)
  }

  function onOpenChange(open: boolean) {
    setOpen(open)
  }

  return {
    onSelectDocument,
    onOpenChange,
  }
}
